import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getMRTimelLinereportslist } from "../../../store/Reports/actions";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class MRTimelLineReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getMRTimelLinereportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });

    const style = document.createElement("style");
    style.innerHTML = `
    @media print {
      @page {
        size: A4 landscape;
        margin: 10mm;
      }

      body {
        zoom: 0.9;
      }

      table {
        width: 100% !important;
        table-layout: fixed;
        font-size: 10px;
      }

      th,
      td {
        padding: 4px !important;
        white-space: nowrap;
      }

      /* ✅ FIX: wrap Item Name only */
      .item-name {
        white-space: normal !important;
        word-break: break-word;
        min-width: 220px;
        max-width: 300px;
      }

      .float-right,
      .btn,
      button,
      .no-print {
        display: none !important;
      }
    }
  `;
    document.head.appendChild(style);
  }

  // componentDidUpdate() {
  //   console.log("MRTimeline_ReportData", this.props.MRTimeline_ReportData)
  //   console.log("MRTimeline_Doc_report", this.props.MRTimeline_Doc_report)

  // }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/mrtimelinereport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={
                            this.props.MRTimeline_ReportData?.map((item) => ({
                              Location: item.location_name || "-",
                              "MR No": item.mr_no || "-",
                              "MR Date": item.mr_date || "-",
                              "Item Name": item.item_name || "-",
                              Quantity: item.qty || "-",
                              User: item.user || "-",
                              Department: item.department || "-",
                              "MR HOD Approved By":
                                item.mr_hod_approved_by || "-",
                              "MR HOD Approved Date":
                                item.mr_hod_approved_date || "-",
                              "Material Approved By":
                                item.material_approved_by || "-",
                              "Material Approved Date":
                                item.material_approved_date || "-",
                              "MR to Material Approved Due Days":
                                item.mr_to_material_approved_due_days ?? "-",
                              "MR Item Status": item.mr_item_status || "-",
                              "PI Code": item.pi_code || "-",
                              "PI Date": item.pi_date || "-",
                              "PI Created By": item.pi_created_by || "-",
                              "PI Approved By": item.pi_approved_by || "-",
                              "MR to PI Due Days":
                                item.mr_to_pi_due_days ?? "-",
                              "PI Item Status": item.pi_item_status || "-",
                              "RFQ No": item.rfq_no || "-",
                              "RFQ Date": item.rfq_date || "-",
                              "PI to RFQ Due Days":
                                item.pi_to_rfq_due_days ?? "-",
                              "RFQ Item Status": item.rfq_item_status || "-",
                              "PO No": item.po_no || "-",
                              "PO Date": item.po_date || "-",
                              "PO Created By": item.po_created_by || "-",
                              "RFQ to PO Due Days":
                                item.rfq_to_po_due_days ?? "-",
                              "Vendor Name": item.vendor_name || "-",
                              "Gate Inward Number":
                                item.gate_inward_number || "-",
                              "Inward Date": item.inward_date || "-",
                              "PO to Gate Inward Due Days":
                                item.po_to_gate_inward_due_days ?? "-",
                              "PO Status": item.po_status || "-",
                            })) || []
                          }
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893",
                            "",
                            "MR TIMELINE REPORT",
                            "",
                          ]}
                          fileName="MR_TIMELINE_REPORT"
                        />

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className="ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        MR TIMELINE REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(y, m, 1)).format("DD-MM-YYYY")
                          : moment(this.props.params.start_date).format(
                              "DD-MM-YYYY"
                            )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        className="mb-0 p-0 table-centered table-color-black"
                      >
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="item-name">Location</th>

                            <th>MR No</th>
                            <th>MR Date</th>
                            <th className="item-name">Item Name</th>
                            <th>Qty</th>

                            <th>User</th>
                            <th>Department</th>

                            <th>HOD Approved By</th>
                            <th>HOD Approved Date</th>
                            <th>MR → Material Due Days</th>
                            <th>MR Item Status</th>

                            <th className="item-name">PI Code</th>
                            <th>PI Date</th>
                            <th>PI Created By</th>
                            <th>PI Approved By</th>
                            <th>MR → PI Due Days</th>
                            <th>PI Item Status</th>

                            <th>RFQ No</th>
                            <th>RFQ Date</th>
                            <th>PI → RFQ Due Days</th>
                            <th>RFQ Item Status</th>

                            <th>PO No</th>
                            <th>PO Date</th>
                            <th>PO Created By</th>
                            <th>RFQ → PO Due Days</th>

                            <th className="item-name">Vendor</th>

                            <th>Gate Inward No</th>
                            <th>Inward Date</th>
                            <th>PO → Gate Due Days</th>

                            <th>PO Status</th>
                          </tr>
                        </thead>

                        <tbody>
                          {this.props.MRTimeline_ReportData?.length ? (
                            this.props.MRTimeline_ReportData.map(
                              (row, index) => (
                                <tr key={index}>
                                  <td className="item-name">
                                    {row.location_name || "-"}
                                  </td>

                                  <td>{row.mr_no || "-"}</td>
                                  <td>{row.mr_date || "-"}</td>
                                  <td className="item-name">
                                    {row.item_name || "-"}
                                  </td>
                                  <td>{row.qty ?? "-"}</td>

                                  <td>{row.user || "-"}</td>
                                  <td>{row.department || "-"}</td>

                                  <td>{row.mr_hod_approved_by || "-"}</td>
                                  <td>{row.mr_hod_approved_date || "-"}</td>
                                  <td>
                                    {row.mr_to_material_approved_due_days ??
                                      "-"}
                                  </td>
                                  <td>{row.mr_item_status || "-"}</td>

                                  <td className="item-name">
                                    {row.pi_code || "-"}
                                  </td>
                                  <td>{row.pi_date || "-"}</td>
                                  <td>{row.pi_created_by || "-"}</td>
                                  <td>{row.pi_approved_by || "-"}</td>
                                  <td>{row.mr_to_pi_due_days ?? "-"}</td>
                                  <td>{row.pi_item_status || "-"}</td>

                                  <td>{row.rfq_no || "-"}</td>
                                  <td>{row.rfq_date || "-"}</td>
                                  <td>{row.pi_to_rfq_due_days ?? "-"}</td>
                                  <td>{row.rfq_item_status || "-"}</td>

                                  <td>{row.po_no || "-"}</td>
                                  <td>{row.po_date || "-"}</td>
                                  <td>{row.po_created_by || "-"}</td>
                                  <td>{row.rfq_to_po_due_days ?? "-"}</td>

                                  <td className="item-name">
                                    {row.vendor_name || "-"}
                                  </td>

                                  <td>{row.gate_inward_number || "-"}</td>
                                  <td>{row.inward_date || "-"}</td>
                                  <td>
                                    {row.po_to_gate_inward_due_days ?? "-"}
                                  </td>

                                  <td>{row.po_status || "-"}</td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={30} className="text-center">
                                No Records Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, MRTimeline_Doc_report, MRTimeline_ReportData } =
    state.reports;
  return {
    params,
    reportType,
    MRTimeline_Doc_report,
    MRTimeline_ReportData,
  };
};

export default connect(mapStatetoProps, {
  getMRTimelLinereportslist,
})(MRTimelLineReportList);
